var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70995 14.8158L13.2182 21.3239C13.8257 21.9313 14.8106 21.9313 15.4181 21.3239C16.0256 20.7164 16.0256 19.7315 15.4181 19.124L11.5299 15.2359L26.4444 15.2359C27.3035 15.2359 28 14.5395 28 13.6804C28 12.8213 27.3035 12.1249 26.4444 12.1249L11.5315 12.1249L15.4181 8.2384C16.0256 7.63093 16.0256 6.64603 15.4181 6.03857C14.8106 5.4311 13.8257 5.4311 13.2182 6.03857L6.70989 12.5467C6.69804 12.5578 6.68632 12.5692 6.67473 12.5808C6.37204 12.8835 6.22017 13.2798 6.21912 13.6766C6.2178 14.0764 6.36967 14.4766 6.67473 14.7817C6.68634 14.7933 6.69808 14.8047 6.70995 14.8158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.60e5db9db18e929e60b282cf1cc8dbfa.svg";
export { ForwardRef as ReactComponent };